var _path, _rect, _rect2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 88,
    viewBox: "0 0 105 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.88343 3.1413L95.6918 29.3872C94.4791 34.0682 97.1896 38.9021 101.862 40.2831C101.962 40.3125 102.062 40.3402 102.162 40.3661L98.9886 51.1034C98.8907 51.0709 98.7918 51.0398 98.6921 51.0103C93.9196 49.5999 88.9073 52.3254 87.4968 57.0979C86.0864 61.8705 88.8119 66.8828 93.5844 68.2932C93.6842 68.3227 93.784 68.3504 93.8839 68.3763L90.8868 78.5177C90.7888 78.4851 90.69 78.4541 90.5903 78.4246C85.8178 77.0142 80.8055 79.7397 79.395 84.5122C79.3655 84.6119 79.3379 84.7117 79.312 84.8116L-9.49638 58.5657C-9.46381 58.4678 -9.43276 58.369 -9.4033 58.2693C-8.02232 53.5965 -10.6063 48.6938 -15.1944 47.1671L-12.1973 37.0257C-7.5163 38.2383 -2.68242 35.5279 -1.30145 30.855C0.0795286 26.1822 -2.50442 21.2796 -7.09258 19.7529L-3.91932 9.01549C0.661777 10.2022 5.38932 7.63157 6.88343 3.1413Z",
    fill: "#006EB8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.595,
    y: 9.95648,
    width: 74.5731,
    height: 49.094,
    transform: "rotate(16.4642 14.595 9.95648)",
    fill: "#006EB8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2706,
    y: 11.1989,
    width: 72.5731,
    height: 47.094,
    transform: "rotate(16.4642 15.2706 11.1989)",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6912 27.606L70.5601 42.0484",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8732 37.1414L67.742 51.5838",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.e46b66b314c9cefb087de31b6bcf511f.svg";
export { ForwardRef as ReactComponent };